export const REQUEST_TABLE_DATE_HEADERS = [
  { text: "تاريخ خدمة العملاء", value: "cs_date", align: "center" },
  { text: "تاريخ الاستشاري", value: "agent_date", align: "center" },
];

export function splitRequestTableDate(value) {
  if (value === null || value === undefined || value === "" || value === "-") {
    return { date: "-", time: "" };
  }

  const parts = String(value).trim().split(" ");
  return {
    date: parts[0] || "-",
    time: parts[1] ? parts[1].split(".")[0] : "",
  };
}
